import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  BrowserRouter as Router,
  // Switch,
  Route,
  Link,
  useParams,
  useLocation,
} from 'react-router-dom'

import { Nav } from './styles'
import { siteMapNavItem } from '../../../types/siteMap'
import { getItemsFromPath } from '../../../utils'
import { updateNav } from '../../../slices/siteMapSlice'

const Navigation = () => {
  const dispatch = useDispatch()
  const nav = useSelector((state: any) => state.siteMap.nav)
  const location = useLocation()

  useEffect(() => {
    const { view, code } = getItemsFromPath(location.pathname)
    if (view) {
      dispatch(updateNav(view))
    }
  }, [location])

  return (
    <Nav>
      {nav.map((item: siteMapNavItem) =>
        item?.id ? (
          <Link key={item.id} to={item.path}>
            {item.name}
          </Link>
        ) : null
      )}
    </Nav>
  )
}

export default Navigation
